module.exports = {
	/**
	 * @type {string}
	 * @description 首页三张背景图
	 */
	bg1: 'https://file.xmyr.top/xmyr/common/bg1.jpg',
	bg2: 'https://file.xmyr.top/xmyr/common/bg2.jpg',
	bg3: 'https://file.xmyr.top/xmyr/common/bg3.jpg',

	/**
	 * @type {string}
	 * @description 首页故障风文字
	 */
	malfunctionText: '寻梦依然的个人空间'
}
